var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGitPullRequestCategory = function SvgGitPullRequestCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#GitPullRequestCategory_svg__GitPullRequestCategory_svg__clip0_669_12095)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18a2 2 0 104 0 2 2 0 00-4 0zM4 6a2 2 0 104 0 2 2 0 00-4 0zm12 12a2 2 0 104 0 2 2 0 00-4 0zM6 8v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h5a2 2 0 012 2v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9l-3-3 3-3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "GitPullRequestCategory_svg__GitPullRequestCategory_svg__clip0_669_12095"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGitPullRequestCategory;